# The React side of the client's router (hash_router.coffee) — card
# 6ac022caa664bc34d57be8c1.
#
# RouterView renders the open route's screen. A screen gets, as props:
#
#   params      the route's params (path, query and non-URL ones)
#   route       route(name, params, options) — the one navigation call
#   back        back() — the browser's back
#   href        href(name, params) — the hash a route opens, for an <a>
#   routeName   the name of the route on screen
#   …and one prop per resolve token of its route (videos, history_item, …).
#
# The screen is keyed by its transition, so opening another route — or the same
# one with different non-dynamic params — mounts it fresh, as ui-router did. A
# change to a DYNAMIC param re-renders it in place.
#
# RouteLink replaces UISref: it hands its one child an href and an onClick that
# navigates, so a MUI Button inside it renders as an <a>, exactly as before.
import React from 'react'

export RouterContext = React.createContext null

export useRouter = -> React.useContext RouterContext

export class RouterView extends React.Component
  constructor: (props) ->
    super props
    @state = {current: props.router.current}

  componentDidMount: ->
    @unsubscribe = @props.router.subscribe (current) => @setState {current}
    # On old iOS the native bridge can announce itself after the first render;
    # the screen re-renders when it does (it was AppListener in app-route).
    document.addEventListener 'el-is-app-changed', @isAppChanged
    @props.router.start()

  componentWillUnmount: ->
    @unsubscribe?()
    document.removeEventListener 'el-is-app-changed', @isAppChanged

  isAppChanged: =>
    @props.onAppChanged?()
    @forceUpdate()

  render: ->
    {router} = @props
    current = @state.current
    Screen = current?.route?.component
    <RouterContext.Provider value={router}>
      {if Screen?
        props = Object.assign {}, current.resolved,
          params: current.params
          route: router.go
          back: router.back
          href: router.href
          routeName: current.name
        <Screen key={current.key} {...props} />
      }
    </RouterContext.Provider>

isPlainLeftClick = (e) ->
  not (e.defaultPrevented or (e.button? and e.button isnt 0) or e.metaKey or e.ctrlKey or e.shiftKey or e.altKey)

export RouteLink = ({to, params, options, children}) ->
  router = React.useContext RouterContext
  child = React.Children.only children
  onClick = (e) ->
    child.props.onClick?(e)
    return unless isPlainLeftClick e
    e.preventDefault()
    router?.go to, params, options
  React.cloneElement child, {href: router?.href(to, params) ? undefined, onClick}
